'use client';

import type { TaxEnrollmentStatus } from '@savvy/constants/generated/gql-enums';

export const StatusOptions: { label: string; value: TaxEnrollmentStatus }[] = [
  { label: 'Not started', value: 'not_started' },
  { label: 'Registered', value: 'registered' },
  { label: 'In progress', value: 'in_progress' },
  { label: 'State submitted', value: 'state_submitted' },
  { label: 'Federal submitted', value: 'federal_submitted' },
  { label: 'State accepted', value: 'state_accepted' },
  { label: 'Federal accepted', value: 'federal_accepted' },
  { label: 'State rejected', value: 'state_rejected' },
  { label: 'Federal rejected', value: 'federal_rejected' },
  { label: 'Not interested', value: 'not_interested' },
];
